/* Total Eyewear — Rx dropdown inputs (v6, 4 Jul 2026).
   Replaces the wizard's six free-text SPH/CYL/AXIS fields with <select>
   dropdowns so extreme or malformed prescriptions cannot be entered.
   RANGES (matched to the lab's Lite STOCK single-vision list, Jan 2025):
   SPH +6.00 → −10.00 in 0.25 steps · CYL ±4.00 in 0.25 steps (per-lens
   limits in the wizard enforce tighter caps) · AXIS 1–180 whole degrees.
   Stronger Rx → “contact our specialists” note. PD keeps free entry +
   camera tool (dual-PD formats like 31/31).
   v5: demo-lens disclosure now names ESSILOR — lenses are the Essilor Lite
   range (Daneev 4 Jul: “technically Essilor lenses”), stated truthfully.
   v6: “genuine” dropped from Essilor wording (Daneev: reads try-hard).
   ⚠️ brief §8 gate: confirm contractual right to use the Essilor name in
   marketing.
   Runs deferred BEFORE DOMContentLoaded so the wizard's init() binds to the
   selects; selects fire 'input' on change, which the wizard listens for.
   Fold into sections/prescription-addon.liquid (with the tint guard and
   mirror preview) on the next full wizard pass. Ranges: SPH_MAX/SPH_MIN/CYL_MAX. */
(function () {
  var SPH_MAX = 6, SPH_MIN = -10, CYL_MAX = 4;
  function fmt(v) {
    var s = v.toFixed(2);
    return v > 0 ? '+' + s : s;
  }
  function sphOptions() {
    var out = [];
    for (var v = SPH_MAX; v >= SPH_MIN - 0.001; v -= 0.25) {
      var r = Math.round(v * 4) / 4;
      out.push([fmt(r), r === 0 ? '0.00 (none / Plano)' : fmt(r)]);
    }
    return out;
  }
  function cylOptions() {
    var out = [];
    for (var v = CYL_MAX; v >= 0.25 - 0.001; v -= 0.25) {
      var r = Math.round(v * 4) / 4;
      out.push([fmt(r), fmt(r)]);
    }
    for (var w = -0.25; w >= -CYL_MAX - 0.001; w -= 0.25) {
      var q = Math.round(w * 4) / 4;
      out.push([fmt(q), fmt(q)]);
    }
    return out;
  }
  function axisOptions() {
    var out = [];
    for (var i = 1; i <= 180; i++) out.push([String(i), String(i)]);
    return out;
  }
  var LISTS = { sph: sphOptions(), cyl: cylOptions(), axis: axisOptions() };
  var BLANK = { sph: 'Select…', cyl: 'None', axis: '—' };

  function kindOf(el) {
    var k = el.getAttribute('data-rx') || '';
    if (/-sph$/.test(k)) return 'sph';
    if (/-cyl$/.test(k)) return 'cyl';
    if (/-axis$/.test(k)) return 'axis';
    return null;
  }

  function swap(el) {
    var kind = kindOf(el);
    if (!kind || el.tagName === 'SELECT') return;
    var sel = document.createElement('select');
    ['data-rx', 'data-rx-field', 'aria-label'].forEach(function (a) {
      var v = el.getAttribute(a);
      if (v) sel.setAttribute(a, v);
    });
    sel.className = 'rxsg-select';
    var opts = '<option value="">' + BLANK[kind] + '</option>';
    var list = LISTS[kind];
    for (var i = 0; i < list.length; i++) {
      opts += '<option value="' + list[i][0] + '">' + list[i][1] + '</option>';
    }
    sel.innerHTML = opts;
    el.parentNode.replaceChild(sel, el);
  }

  function addNote() {
    var table = document.querySelector('.prescription-addon .rx-table');
    if (!table || document.querySelector('.rxsg-note')) return;
    var p = document.createElement('p');
    p.className = 'rxw-help rxsg-note';
    p.style.margin = '0 0 14px';
    p.innerHTML = 'Prescription stronger than these ranges? We can often still help — <a href="/pages/contact">contact our specialist team</a> for a personal quote.';
    table.parentNode.insertBefore(p, table.nextSibling);
  }

  function addDemoLensNote() {
    var notice = document.querySelector('.prescription-addon .rx-notice');
    if (!notice || notice.querySelector('.rxsg-demolens')) return;
    var s = document.createElement('span');
    s.className = 'rxsg-demolens';
    s.innerHTML = '&#128295; Your new lenses are made by <strong>Essilor</strong>, the world’s leading lens maker, to your exact prescription and fitted by our specialist lab. They replace the lenses supplied with the frame — including any branded demo or sunglass lenses — so logos etched on the original lenses (Ray-Ban, Oakley and others) won’t appear on your new lenses. Your frame itself remains 100% genuine.';
    notice.appendChild(s);
  }

  function boot() {
    var fields = document.querySelectorAll('.prescription-addon [data-rx]');
    if (!fields.length) return;
    var css = document.createElement('style');
    css.textContent = '.rx-table select.rxsg-select{width:100%;border:1px solid #e8e4df;border-radius:3px;padding:8px 4px;font-size:0.8rem;text-align:center;color:#1a1a1a;background:#fafaf9;box-sizing:border-box;}.rx-table select.rxsg-select:focus{outline:2px solid #1c2b3a;outline-offset:1px;background:#fff;}';
    document.head.appendChild(css);
    for (var i = 0; i < fields.length; i++) swap(fields[i]);
    addNote();
    addDemoLensNote();
  }

  /* Deferred scripts run before DOMContentLoaded, so this executes ahead of
     the wizard's init() listener. Run immediately; fall back if needed. */
  boot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();

/* v7 (6 Jul 2026): review-step summary fix — the wizard's rxVals() strips
   the leading "+" (and trailing zeros) from SPH for its internal maths, and
   the summary printed those numbers. Data sent to cart was always correct;
   this rewrites the displayed Prescription row from the raw select values
   ("+2.00" stays "+2.00"). Pure display patch, no wizard logic touched. */
(function () {
  function val(name) {
    var el = document.querySelector('.prescription-addon [data-rx="' + name + '"]');
    return el ? (el.value || '') : '';
  }
  function eye(p) {
    var s = val(p + '-sph') || '0.00';
    var c = val(p + '-cyl');
    var out = s;
    if (c && parseFloat(c)) out += ' / ' + c + ' × ' + val(p + '-axis');
    return out;
  }
  function build() {
    if (!document.querySelector('.prescription-addon [data-rx="r-sph"]')) return null;
    return 'R: ' + eye('r') + ' · L: ' + eye('l');
  }
  var busy = false;
  function fix() {
    if (busy) return;
    var txt = build();
    if (!txt) return;
    var rows = document.querySelectorAll('[data-rxw-summary] .rxw-summary__row');
    for (var j = 0; j < rows.length; j++) {
      var span = rows[j].querySelector('span');
      var strong = rows[j].querySelector('strong');
      if (!span || !strong) continue;
      if (span.textContent.indexOf('Prescription') !== 0) continue;
      if (strong.children.length === 0) {
        if (strong.textContent !== txt) { busy = true; strong.textContent = txt; busy = false; }
      } else {
        for (var k = 0; k < strong.childNodes.length; k++) {
          var n = strong.childNodes[k];
          if (n.nodeType === 3 && n.nodeValue.replace(/\s/g, '')) {
            if (n.nodeValue !== txt) { busy = true; n.nodeValue = txt; busy = false; }
            break;
          }
        }
      }
    }
  }
  function start() {
    if (!document.querySelector('.prescription-addon')) return;
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true, characterData: true });
    fix();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
